import React, { useEffect, useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchDepartments } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";

const DepartmentDropdown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
  required,
}) => {
  const deptName = getValues().dept_name;
  const selectedDepartment = watch("dept_id");

  const {
    data: departments,
    isLoading,
    error,
  } = useQuery(["departments"], () => fetchDepartments(), {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  const options = useMemo(
    () =>
      departments?.data?.data?.map((department) => ({
        value: department.dept_id,
        label: department.department,
      })) || [],
    [departments]
  );

  useEffect(() => {
    if (rowData && options.length) {
      const selectedOption =
        options.find((option) => option.value === rowData?.dept_obj?.dept_id) ||
        options.find((option) => option.value === rowData?.lab_department_id);

      setValue("dept_id", selectedOption?.value);
    }
  }, [rowData, options, setValue]);

  // const selectedOption = options.find(
  //   (option) => option.value === selectedDepartment || deptName
  // );

  const selectedOption =
    options.find((option) => option.value === selectedDepartment) ||
    options.find((option) => option.value === rowData?.dept_obj?.dept_id) ||
    options.find((option) => option.value === rowData?.lab_department_id) ||
    options.find((option) => option.label === deptName) ||
    null;

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Departments</div>;

  return (
    <Controller
      name="dept_id"
      control={control}
      rules={{
        required: required ? "Department is required" : false,
        validate: (value) => {
          if (required && !value) return "Department is required";
          return true;
        },
      }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          value={selectedOption || null}
          placeholder="Select Department"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : "";
            field.onChange(value);
            setValue("dept_id", value);
          }}
          className={`react-select-container ${
            errors.dept_id ? "is-invalid" : ""
          }`}
        />
      )}
    />
  );
};

export default DepartmentDropdown;
